import { isPartnerLaunch } from './partner-launch-sandbox';

const EMBED_RETURN_KEY = 'arsEmbedReturn';

const EMBED_PASSTHROUGH = [
  '/embed',
  '/login',
  '/signup',
  '/emailverify',
  '/account-confirmation',
  '/password',
  '/pricing'
];

export function captureArsEmbedReturn(): void {
  if (typeof window === 'undefined') return;
  const path = window.location.pathname || '';
  if (!path.startsWith('/embed')) return;
  try {
    sessionStorage.setItem(EMBED_RETURN_KEY, path + window.location.search);
  } catch {}
}

export function arsEmbedReturnUrl(): string | null {
  try {
    const value = sessionStorage.getItem(EMBED_RETURN_KEY);
    if (value && value.startsWith('/embed')) return value;
  } catch {}
  return null;
}

export function isArsEmbedContext(): boolean {
  if (typeof window === 'undefined') return false;
  const path = window.location.pathname || '';
  if (path.startsWith('/embed')) return true;
  try {
    return window.self !== window.top && !!arsEmbedReturnUrl();
  } catch {
    return false;
  }
}

export function initArsEmbedShell(): boolean {
  captureArsEmbedReturn();
  return isArsEmbedContext();
}

export function shouldStayInsideEmbed(url: string): boolean {
  const path = (url || '').split('?')[0];
  if (isPartnerLaunch()) return !(path === '/embed' || path.startsWith('/embed/'));
  if (!isArsEmbedContext()) return false;
  return !EMBED_PASSTHROUGH.some(prefix => path === prefix || path.startsWith(prefix + '/'));
}
